import { useOutletContext } from 'react-router'
import { ButtonLinkLegacy } from '@/components/ui/button-link-legacy'
import { DownloadCloud02Icon, ImageCheckIcon } from '@/components/ui/icons'
import { Spinner } from '@/components/ui/spinner'
import { PhotosetFinal } from '@/features/photoset/components/photoset-final'
import { useGetPhotoset } from '@/features/photoset/queries/use-get-photoset'
import type { PhotosetURLParams } from '@/features/photoset/types'
import { useTranslation } from '@/translations/i18n'

export const PhotosetRetouchingRevisionApprovedStep = () => {
	const { t } = useTranslation()
	const { urlParams } = useOutletContext<{ urlParams: PhotosetURLParams }>()
	const photosetQuery = useGetPhotoset(
		{
			id: urlParams.id
		},
		{ enabled: false }
	)

	return (
		<PhotosetFinal
			endSlot={
				<ButtonLinkLegacy
					disabled={!photosetQuery?.data?.revised_zip_url}
					size='lg'
					target='_blank'
					to={photosetQuery?.data?.revised_zip_url || ''}
				>
					{photosetQuery?.data?.revised_zip_url ? (
						<>
							<DownloadCloud02Icon size={20} />
							<span>{t('common:download_zip')}</span>
						</>
					) : (
						<>
							<Spinner size={20} />
							<span>{t('common:creating_zip')}</span>
						</>
					)}
				</ButtonLinkLegacy>
			}
			icon={<ImageCheckIcon className='fill-neutral-900' size={38} />}
			isLoading={photosetQuery.isFetching}
			subtitle={t('photoset:retouching_revision_approved.subtitle')}
			title={t('photoset:retouching_revision_approved.title')}
		/>
	)
}
